import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const DashboardTab = ({ userData }) => {
  const [chartPeriod, setChartPeriod] = useState("7");

  const views = userData.stats.viewsData[chartPeriod] || [];
  const chartData = {
    labels: views?.map((item) => item.date),
    datasets: [
      {
        label: "Profile Views",
        data: views?.map((item) => item.totalViews),
        borderColor: "#6c5ce7",
        backgroundColor: "rgba(108, 92, 231, 0.08)",
        tension: 0.35,
        fill: true,
        pointRadius: 2,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { mode: "index", intersect: false },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, grid: { color: "rgba(0,0,0,0.05)" } },
    },
  };

  return (
    <div>
      <h2 className="section-title">
        <FontAwesomeIcon icon={faChartLine} /> Profile Analytics
      </h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">
            {userData.stats.totalViews.toLocaleString()}
          </div>
          <div className="stat-label">Total Views</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            {userData.stats.uniqueVisitors.toLocaleString()}
          </div>
          <div className="stat-label">Unique Visitors</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            {userData.stats.bioscore.toLocaleString()}
          </div>
          <div className="stat-label">BioScore</div>
        </div>
      </div>

      <div className="time-filters">
        {["7", "30", "90"].map((p) => (
          <button
            key={p}
            className={`time-filter ${chartPeriod === p ? "active" : ""}`}
            onClick={() => setChartPeriod(p)}
          >
            Last {p} Days
          </button>
        ))}
      </div>

      <div className="chart-container" style={{ height: 320 }}>
        <Line data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default DashboardTab;
